import { useEffect, useState } from "react";

// The chat's own short notice - a small dark pill at the bottom, like WhatsApp's. Kept
// apart from the app's general toast, which looks out of place in a chat. One at a
// time: a new one replaces the one showing.
let current = null;
let timer = null;
let nextId = 1;
const listeners = new Set();

const emit = () => listeners.forEach((listener) => listener(current));

// action (optional): { label, onClick } - one button on the notice, e.g. "Try again"
export const showChatNotice = (text, durationMs = 2600, action = null) => {
  clearTimeout(timer);
  current = { id: nextId, text, action };
  nextId += 1;
  emit();
  timer = setTimeout(() => {
    current = null;
    timer = null;
    emit();
  }, durationMs);
};

export const hideChatNotice = () => {
  clearTimeout(timer);
  timer = null;
  current = null;
  emit();
};

// Mount once on the chat page
export const ChatNoticeHost = () => {
  const [notice, setNotice] = useState(current);
  useEffect(() => {
    listeners.add(setNotice);
    return () => listeners.delete(setNotice);
  }, []);
  return notice ? (
    <div className="chat-notice" role="status">
      {notice.text}
      {notice.action && (
        <button
          type="button"
          className="chat-notice-action"
          onClick={() => {
            hideChatNotice();
            notice.action.onClick();
          }}
        >
          {notice.action.label}
        </button>
      )}
    </div>
  ) : null;
};
